import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { StateService } from "./state.service";
import { CatExpertRouterLink } from "../app-routing-enum";

@Injectable({
  providedIn: "root",
})
export class DomainNavigationService {
  constructor(
    private router: Router,
    private stateService: StateService
  ) {}

  /**
   * Navigate to the default route based on domain configuration
   */
  navigateToDefaultRoute(): void {
    const domainType = this.stateService.checkAppConfig();

    if (domainType === "ai-imagery") {
      this.router.navigateByUrl("/ai-imagery");
    } else {
      this.router.navigateByUrl("/studio");
    }
  }

  /**
   * Get the default redirect URL for login based on domain
   */
  getLoginRedirectUrl(): string {
    const domainType = this.stateService.checkAppConfig();
    const currentOrigin = window.location.origin;

    if (domainType === "ai-imagery") {
      return `${currentOrigin}/ai-imagery`;
    } else {
      return `${currentOrigin}/studio`;
    }
  }

  /**
   * Get domain type from current hostname (for production environments)
   */
  getDomainTypeFromHostname(): string {
    const hostname = window.location.hostname;

    if (hostname.includes("ai-imagery")) {
      return "ai-imagery";
    } else if (hostname.includes("catexpert")) {
      return "catexpert";
    } else if (hostname.includes("pho")) {
      return "pho";
    } else if (hostname.includes("space")) {
      return "space";
    }

    // Fallback to config file for development
    return this.stateService.checkAppConfig();
  }

  /**
   * Check if the current domain has access to a specific feature
   */
  hasFeatureAccess(feature: string): boolean {
    const domainType = this.stateService.checkAppConfig();

    switch (feature) {
      case "ai-imagery":
        return domainType === "ai-imagery";
      case "catexpert":
        return domainType === "catexpert" || domainType === "space";
      case "pho":
        return domainType === "pho";
      default:
        return true;
    }
  }

  /**
   * Get the main navigation path based on domain
   */
  getMainNavigationPath(): string {
    const domainType = this.stateService.checkAppConfig();

    if (domainType === "ai-imagery") {
      return "/ai-imagery";
    } else {
      return "/studio";
    }
  }
}
